module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/3-1d89b2a9f8f172de6e44b4f2b9d8cadc.webp";